// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"b5522acb","85":"79eee1c0","176":"ac8c46c0","771":"dda67857","848":"21d0c90c","868":"7713db68","890":"ccfd4e80"}[chunkId] + ".chunk.js";
};